import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/Sli/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is an SLI?
          </h2>
          <p className={cn('about__paragraph')}>
            The SLI is more than just a document, it’s like a written go-ahead that spells out all the
            important details of the shipment: who’s involved, where it’s headed, and how it’s getting
            there. It also includes clear instructions about insurance, paperwork, and specific filings
            needed for US exports. Think of it like a contract for moving goods. It keeps the forwarder safe
            by confirming, “I’m following exactly what the customer asked,” and it protects the shipper by
            making sure their cargo doesn’t get lost or left uninsured.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href="/download/Resources/FreightTemplates/shipper's_letter_of_instruction.doc"
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href="/download/Resources/FreightTemplates/shipper's_letter_of_instruction.pdf"
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;